import { render, staticRenderFns } from "./PolimorficCarousel.vue?vue&type=template&id=be58ea88&scoped=true&"
import script from "./PolimorficCarousel.vue?vue&type=script&lang=js&"
export * from "./PolimorficCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PolimorficCarousel.vue?vue&type=style&index=0&id=be58ea88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be58ea88",
  null
  
)

export default component.exports